import { Btn, Card, F, PageHeader, Toggle, num } from "../../components/admin/ui";
import { useSettingsDoc } from "../../components/admin/useSettingsDoc";
import { ListEditor } from "./Content";

export default function Settings() {
  const { s, patch, save, busy } = useSettingsDoc();
  if (!s) return null;
  const b = (path) => ({ value: path.split(".").reduce((o, k) => o?.[k], s), onChange: (v) => patch(path, v) });
  return (
    <div data-testid="admin-settings">
      <PageHeader title="إعدادات المتجر">
        <Btn data-testid="save-settings-button" onClick={save} disabled={busy}>حفظ الإعدادات</Btn>
      </PageHeader>
      <div className="grid gap-4 lg:grid-cols-2">
        <Card title="بيانات التواصل">
          <div className="grid gap-3 sm:grid-cols-2">
            <F label="رقم الجوال" dir="ltr" testid="settings-phone-input" {...b("contact.phone")} />
            <F label="واتساب (مع رمز الدولة)" dir="ltr" {...b("contact.whatsapp")} />
            <F label="البريد الإلكتروني" dir="ltr" {...b("contact.email")} />
            <F label="رابط إنستغرام" dir="ltr" {...b("contact.instagram")} />
            <F label="رابط سناب شات" dir="ltr" {...b("contact.snapchat")} />
            <F label="رابط تيك توك" dir="ltr" {...b("contact.tiktok")} />
            <F label="رابط X" dir="ltr" {...b("contact.x")} />
          </div>
        </Card>
        <Card title="الدفع">
          <div className="space-y-2">
            <Toggle label="الدفع عند الاستلام" testid="settings-cod-toggle" checked={s.payment?.cod_enabled} onChange={(v) => patch("payment.cod_enabled", v)} />
            <F label="رسوم الدفع عند الاستلام (ر.س)" type="number" value={s.payment?.cod_fee} onChange={(v) => patch("payment.cod_fee", num(v))} />
            <Toggle label="الدفع الإلكتروني عبر ميسر (مدى، فيزا، ماستركارد)" testid="settings-online-toggle" checked={s.payment?.online_enabled} onChange={(v) => patch("payment.online_enabled", v)} />
            <div className="rounded border border-dashed border-gray-300 p-3 text-xs leading-5 text-gray-500">الطلب الإلكتروني يبدأ «بانتظار الدفع» ويتحول تلقائيًا إلى «مدفوع» بعد تحقق الخادم من ميسر. الاسترداد المالي يتم من لوحة ميسر.</div>
          </div>
        </Card>
        <Card title="الضريبة">
          <div className="space-y-2">
            <Toggle label="تفعيل ضريبة القيمة المضافة" checked={s.tax?.enabled} onChange={(v) => patch("tax.enabled", v)} />
            <Toggle label="الأسعار شاملة الضريبة" checked={s.tax?.inclusive} onChange={(v) => patch("tax.inclusive", v)} />
            <div className="grid grid-cols-2 gap-3">
              <F label="النسبة %" type="number" value={s.tax?.rate} onChange={(v) => patch("tax.rate", num(v))} />
              <F label="الرقم الضريبي" dir="ltr" {...b("tax.vat_number")} />
            </div>
          </div>
        </Card>
        <Card title="عام">
          <div className="space-y-3">
            <Toggle label="تفعيل القائمة البريدية" testid="settings-newsletter-toggle" checked={s.newsletter_enabled} onChange={(v) => patch("newsletter_enabled", v)} />
            <F label="مدة الاسترجاع بالأيام (تبقى الأرباح معلّقة خلالها)" type="number" testid="settings-return-days" value={s.return_days ?? 7} onChange={(v) => patch("return_days", Math.max(0, parseInt(v || "0", 10)))} />
            <F label="المدن المقترحة في صفحة الطلب (افصلي بفاصلة)" textarea value={(s.cities || []).join("، ")} onChange={(v) => patch("cities", v.split(/[,،]/).map((x) => x.trim()).filter(Boolean))} />
          </div>
        </Card>
        <Card title="جدول المقاسات" className="lg:col-span-2">
          <ListEditor testid="sizechart" items={s.size_chart || []} onChange={(v) => patch("size_chart", v)} empty={{ size: "", length: "", bust: "", height_ar: "", height_en: "" }}
            fields={[["size", "المقاس", true], ["length", "الطول (سم)", true], ["bust", "الصدر (سم)", true], ["height_ar", "الطول المناسب"], ["height_en", "Height (EN)", true]]} />
        </Card>
        <Card title="السياسات" className="lg:col-span-2">
          <div className="grid gap-3 sm:grid-cols-2">
            {[["shipping", "سياسة الشحن"], ["returns", "الاستبدال والإرجاع"], ["privacy", "الخصوصية"], ["terms", "الشروط والأحكام"]].map(([k, l]) => (
              <div key={k} className="contents">
                <F label={l} textarea {...b(`pages.${k}_ar`)} />
                <F label={`${l} (EN)`} textarea dir="ltr" {...b(`pages.${k}_en`)} />
              </div>
            ))}
          </div>
        </Card>
        <Card title="الأسئلة الشائعة" className="lg:col-span-2">
          <ListEditor testid="faq" items={s.faq || []} onChange={(v) => patch("faq", v)} empty={{ q_ar: "", a_ar: "", q_en: "", a_en: "" }}
            fields={[["q_ar", "السؤال"], ["q_en", "Question", true], ["a_ar", "الإجابة", false, true], ["a_en", "Answer", true, true]]} />
        </Card>
      </div>
    </div>
  );
}
